<template>
  <div v-if="filteredOptions.length">
    <label class="font-bold"> {{ name }} {{ required ? "*" : "" }} </label>
    <div class="flex flex-col">
      <b-radio
        v-for="(option, index) in filteredOptions"
        :key="`${index}-option`"
        :name="name"
        :native-value="nativeValue(option)"
        :value="value"
        @input="valueChange($event)"
        @select="onSelect(nativeValue(option))"
      >
        {{ option.name }} - {{ item[option.name] }}
      </b-radio>
    </div>
  </div>
</template>

<script>
import BRadio from "./BRadio";

export default {
  name: "BSingleOptionSelection",

  components: {
    BRadio
  },

  props: {
    item: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: { type: Object, default: null },
    required: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    filteredOptions() {
      return this.options.filter(opt => {
        return this.item[opt.name];
      });
    }
  },

  methods: {
    valueChange(item) {
      this.$emit("input", item);
    },
    onSelect(option) {
      if (
        this.value?.name === option?.name &&
        this.value?.value === option?.value
      ) {
        this.$emit("input", null);
      }
    },
    nativeValue(option) {
      return {
        name: option.name,
        value: this.item[option.name]
      };
    }
  }
};
</script>
